import { upsertStyleTag, removeStyleTag } from "../../domStyles";

const ROOT = document.documentElement;

const CLASS = "incluway-high-contrast";
const STYLE_ID = "incluway-high-contrast-style";
const EXCLUDE = "#incluway-widget-root";

export function enableHighContrast() {
  ROOT.classList.remove("incluway-dark-contrast", "incluway-light-contrast");
  ROOT.classList.add(CLASS);

  upsertStyleTag(
    STYLE_ID,
    `
html.${CLASS} body > *:not(${EXCLUDE}) {
  filter: contrast(150%) !important;
}
`.trim(),
  );
}

export function disableHighContrast() {
  ROOT.classList.remove(CLASS);
  removeStyleTag(STYLE_ID);
}
